import { getIn, useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import { FormLabel } from './FormLabel';
import Select from './Selector';
import { useEdit } from '../../Services/EditContext';
import ErrorMessage from './ErrorMessage'
import CompareFormValue from './CompareFormValue';
import { Label } from 'reactstrap';
const AircraftTypes = ({ compare, id, list, noEdit, indicitave, ...myProps }) => {


    const [selection, setSelection] = useState();
    const [originalSelection, setOriginalSelection] = useState();
    const [options, setOptions] = useState(list?.map((m) => { return { value: m.referenceId, label: m.value }; }));
    const { setFieldValue, values } = useFormikContext();
    const [edit] = useEdit();
    const value = values[id];
    const orig = getIn(values, 'original.' + id);
    const original = orig ? orig : null;
    useEffect(() => {
        if (list) {
            setOptions(list?.map((m) => { return indicitave ? { value: m.id, label: m.category, ...m } : { value: m.referenceId, label: m.value }; }));

        }
    }, [value, list, indicitave])
    useEffect(() => {
        if (!indicitave) {
            const values = value ? value.split(',') : [];
            setSelection(options?.filter(x => { return values.find(y => { return y === x.label }) }));
        }
        else {
            setSelection(value);
        }
    },
        [value, options, indicitave]);
    useEffect(() => {
        if (!indicitave) {
            const values = original ? original.split(',') : [];
            setOriginalSelection(options?.filter(x => { return values.find(y => { return y === x.label }) }));
        }
        else {
            setOriginalSelection(original);
        }
    },
        [original, options, indicitave]);

    const onSelectChange = val => {

        const newValue = indicitave ? val : val ? val.map(x => { return x.label }).join(',') : "";
        setFieldValue(id, newValue);


    }
    const aircraftPreference = (selection) => selection && selection.length ? selection.map(x => x.label).join(',') : compare ? 'No Preference' : null;
    return <React.Fragment>

        <FormLabel htmlFor="aircraftTypes">
            Aircraft Preference

        </FormLabel>

        {!noEdit && edit ? <Select onChange={onSelectChange} value={selection} isMulti options={options} name={id} {...myProps} id={id} /> :
         <CompareFormValue originalContent={original ? aircraftPreference(originalSelection) : null} prefferedLabelColor={selection && selection[0]?.label === 'TWIN ENGINE ONLY' ? 'red' : null} >{aircraftPreference(selection)}</CompareFormValue>
        }
        <ErrorMessage name={id} />
    </React.Fragment>;
};
export default AircraftTypes; 